<template>
    <div class="async-status">
        <spinner v-if="spinning" size="small" />

        <Transition>
            <i class="fa-solid fa-circle-check" style="color: green;" v-if="successful"></i>
        </Transition>

        <Transition>
            <i class="fa-solid fa-circle-xmark" style="color: red;" v-if="failed"></i>
        </Transition>
    </div>
</template>

<script>
export default {
    data() {
        return {
            spinning: false,
            successful: false,
            failed: false,
        };
    },

    methods: {
        spin() {
            this.spinning = true;
        },

        success() {
            this.spinning = false;
            this.successful = true;
            setTimeout(() => {this.successful = false;}, 2000);
        },

        failure() {
            this.spinning = false;
            this.failed = true;
            setTimeout(() => {this.failed = false;}, 2000);
        }
    }
}
</script>

<style lang="scss" scoped>
.async-status {
     height: 1rem;
     width: 1rem;
     position: relative;
     display: inline-block;

     & > div,
     & > i {
         position: absolute;
         top: 0;
         left: 0;
     }

    .v-enter-from,
    .v-enter-to,
    .v-leave-from {
        opacity: 1;
    }

    .v-leave-active {
        transition: opacity 0.5s ease;
    }

    .v-leave-to {
        opacity: 0;
    }
}
</style>